import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'trqk-mark';

const originalDimensions = {
    width: 153.21,
    height: 81.51,
};

export const IconTrqkBeta = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'primary-500';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            data-name="Layer 1"
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Trqk Beta logo</title>
            <path
                d="M82.9 33.8h-.1M32.7 3.6H3.4A3.37 3.37 0 000 7a3.37 3.37 0 003.4 3.4h11.1v37.7a3.59 3.59 0 003.6 3.6 3.59 3.59 0 003.6-3.6V10.4h11.1A3.37 3.37 0 0036.2 7a3.59 3.59 0 00-3.5-3.4zm79.2 26.1l7.6-7.9a3.35 3.35 0 00-2.4-5.7 3.49 3.49 0 00-2.4 1L102 30.2V3.6A3.59 3.59 0 0098.4 0a3.59 3.59 0 00-3.6 3.6v44.2a3.59 3.59 0 003.6 3.6 3.59 3.59 0 003.6-3.6v-7.9l3.9-4a15.68 15.68 0 0114.8 12.6 3.54 3.54 0 003.5 2.9 3.6 3.6 0 003.5-4.3 23 23 0 00-15.8-17.4zm-76.1 2.7a11 11 0 0110.1-10.9h1.5a3.62 3.62 0 003.7-2.3 3.59 3.59 0 00-3-4.8 18.48 18.48 0 00-2.3-.1c-9.5.3-17.2 8.7-17.2 18.1v15.5a3.59 3.59 0 003.6 3.6 3.59 3.59 0 003.6-3.6zm36.6-18.1a19.035 19.035 0 10-3.6 37.9 18.51 18.51 0 007.1-.7 3.42 3.42 0 002.5-3.3v-.3a3.49 3.49 0 00-4.5-3.3 11.66 11.66 0 01-4.6.4 11.86 11.86 0 012.3-23.6c6 .5 10.8 6.1 10.8 12.1v27.7a3.59 3.59 0 003.6 3.6 3.59 3.59 0 003.6-3.6V33.6a19.24 19.24 0 00-17.2-19.3z"
                fill={fill}
            />
            <path
                d="M100.71 60.3H148a5.12 5.12 0 015.22 5.21v10.78a5.12 5.12 0 01-5.22 5.22h-47.29a5.12 5.12 0 01-5.21-5.22V65.51a5.12 5.12 0 015.21-5.21z"
                fill="#3fc2ce"
                fillRule="evenodd"
            />
            <path
                d="M112.19 70.56a2.35 2.35 0 001.21-1 1.87 1.87 0 00.35-1.39 2.26 2.26 0 00-1.22-2.08 5.75 5.75 0 00-3.3-.7h-5.73v11.08h6.08a6 6 0 003.48-.87 2.36 2.36 0 001.21-2.26 2.91 2.91 0 00-.52-1.74 5.91 5.91 0 00-1.56-1.04zm-6.26-3.65h3.13a3.82 3.82 0 011.74.34 1.49 1.49 0 01.69 1.22 1.32 1.32 0 01-.69 1.22 4.49 4.49 0 01-1.74.34h-3.13zm3.65 8h-3.65V71.6h3.65q2.61 0 2.61 1.56c0 1.05-.87 1.74-2.61 1.74zm14.25-6.6a5.84 5.84 0 00-4.86 0 4.76 4.76 0 00-1.74 1.56 4.92 4.92 0 00-.7 2.26 3.51 3.51 0 00.7 2.26 3.78 3.78 0 001.77 1.55 6.26 6.26 0 002.6.53 6.6 6.6 0 002.09-.35 2.51 2.51 0 001.56-1L124 73.86a3.3 3.3 0 01-2.44.87 4.17 4.17 0 01-2.08-.52 2.58 2.58 0 01-1-1.57h7.31v-.54a4.8 4.8 0 00-.53-2.26c-.04-.5-.56-1.02-1.43-1.54zm-5 3.12a2.87 2.87 0 01.87-1.56 3.17 3.17 0 013.48 0 2.38 2.38 0 01.87 1.56zm14.08 3.48a1.31 1.31 0 01-.87-.35 1.33 1.33 0 01-.34-.87v-4h2.43V68.1h-2.43v-1.89h-2.3v1.89h-1.57v1.57h1.57v4.17a2.86 2.86 0 00.86 2.08 3.39 3.39 0 002.44.7 3 3 0 001.21-.17c.35-.18.7-.18.87-.35l-.52-1.39c-.52.02-.87.19-1.39.19zM144 68.82a5.19 5.19 0 00-3.13-.87 7.24 7.24 0 00-2.09.35 18.57 18.57 0 00-1.74.69l.87 1.39a2.77 2.77 0 011.22-.69 4.63 4.63 0 011.56-.18 2.64 2.64 0 011.74.52 1.71 1.71 0 01.52 1.39v.18h-2.43a4.69 4.69 0 00-3 .69 2.06 2.06 0 00-.86 1.92 4.22 4.22 0 00.34 1.39 3.31 3.31 0 001.22.87 4.62 4.62 0 003.48 0 3.19 3.19 0 001.3-.87v1h2v-5a3.21 3.21 0 00-1-2.78zm-1.05 5a4.45 4.45 0 01-.87 1 3.26 3.26 0 01-1.39.35 2 2 0 01-1.21-.35 1 1 0 01-.52-.87c0-.69.69-1.21 1.91-1.21h2.26v1z"
                fill="#fff"
            />
        </svg>
    );
};
